const translations = {
  "en": {
    "CEX": "CEX"
  },
  "zh-tw": {
    "CEX": "CEX"
  }
};

export default translations;
